import { AbsoluteCenter, Box, Flex, Image } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { COMMON_WEB_PATH } from '../../constant';
import useCheckLogin from '../../hook/useCheckLogin';
import Balance from '../Balance/Balance';
import BetRecordButton from '../BetRecordButton/BetRecordButton';
import ClearCashRegisterButton from '../ClearCash/ClearCashRegisterButton';
import CnyGoldBlessing from '../NewYearDecorations/components/CnyGoldBlessing';
import AnnouncementButton from './HeaderComponents/AnnouncementButton';
import LngButton from './HeaderComponents/LngButton';
import LoginButton from './HeaderComponents/LoginButton';
import MusicToggleButton from './HeaderComponents/MusicToggleButton';
import ReloadButton from './HeaderComponents/ReloadButton';
import UidBanner from './HeaderComponents/UidBanner';
import UserButton from './HeaderComponents/UserButton';

const Header = () => {
  const { isLogin, isMachineDomain, isMachineUser } = useCheckLogin();

  const memberInfo = useSelector((state) => state.isMemberInfo);

  return (
    <Box
      width={{
        base: `100%`,
        xl: `100%`
      }}
      minHeight={{
        base: '65px',
        sm: '70px',
        md: '100px',
        xl: '125px'
      }}
      h={{
        base: '65px',
        sm: '70px',
        md: '100px',
        xl: '125px'
      }}
      position="fixed"
      mx="auto"
      top="0px"
      bgImage={`url(${COMMON_WEB_PATH}/blue-layout/header/header_background.png)`}
      _after={{
        base: {
          content: "''",
          position: 'absolute',
          top: 0,
          left: 0,
          bgSize: '100%100%',
          bgRepeat: 'no-repeat',
          bgPosition: 'center',
          bgImage: `url(${COMMON_WEB_PATH}/blue-layout/header/header_logo_banner.png)`,
          w: {
            base: '30%',
            xl: '25%'
          },
          h: '100%',
          pointerEvents: 'none'
        }
      }}
      bgSize="102% 106%"
      zIndex={{
        base: '999',
        sm: '1001'
      }}
      display="flex"
      pb={{
        base: '0px',
        lg: '10px'
      }}
      alignItems={'flex-start'}
      justifyContent="space-between"
      transition="all 0.3s ease" // 過渡
      pr={{
        base: '1em',
        md: 'unset'
      }}
    >
      <Flex
        alignItems={'flex-start'}
        justifyContent={'space-between'}
        width="100%"
        height="100%"
        pt={'5px'}
      >
        <Flex
          alignItems={'center'}
          justifyContent={'center'}
          position="relative"
          w={{
            base: '30%',
            xl: '25%'
          }}
          h="100%"
          zIndex={1}
        >
          <AbsoluteCenter
            display="flex"
            alignContent={'center'}
            justifyContent={'center'}
            w="100%"
            h="100%"
          >
            <Image
              src={`${COMMON_WEB_PATH}/blue-layout/logo_192.png`}
              alt="Logo"
              objectFit="cover"
              width="100%"
              maxW={{
                base: '85px',
                md: '170px'
              }}
              height="100%"
            />
          </AbsoluteCenter>
          <CnyGoldBlessing />
        </Flex>

        <Flex
          flex={1}
          gap={{
            base: '5px',
            md: '30px'
          }}
          mr={{
            base: 0,
            md: '5%'
          }}
          justifyContent={'flex-end'}
        >
          <Flex gap="25px" alignItems={'center'}>
            {/* 餘額 */}
            {isLogin ? (
              <Flex gap="5px" alignItems={'center'}>
                <Balance />
              </Flex>
            ) : null}
            {isMachineUser || isMachineDomain ? (
              <Flex gap="10px">
                {/* 棄分按鈕 */}
                <ClearCashRegisterButton />
                {/* 投注記錄 */}
                <BetRecordButton />
              </Flex>
            ) : null}
          </Flex>
          {isMachineUser || isMachineDomain ? <UidBanner /> : null}
          <Flex
            gap={{
              base: '5px',
              md: '10px'
            }}
          >
            <Box
              display={{
                base: 'none',
                md: 'flex'
              }}
              alignItems={'center'}
            >
              <LngButton />
            </Box>
            {/* 重整按鈕 */}{' '}
            <Box
              display={{
                base: 'none',
                md: 'flex'
              }}
              alignItems={'center'}
              gap={'0.5em'}
            >
              <ReloadButton />
              <MusicToggleButton />
              <AnnouncementButton />
            </Box>
            {isLogin ? (
              isMachineDomain || isMachineUser ? null : (
                <UserButton />
              )
            ) : (
              <LoginButton />
            )}
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Header;
